import { useT } from "@/i18n";

import { LicenseSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type LicenseSearchItemViewProps = {
  item: LicenseSearchItem;
};

export const LicenseSearchItemView = ({ item }: LicenseSearchItemViewProps) => {
  const t = useT();

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.license.title}</SearchItemLabel>
          <SearchItemDescription>
            {t("general.globalSearch.license.subtitle")}
          </SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="license" />
      </div>
    </div>
  );
};
